export default {
  namespaced: true,
  // eslint-disable-next-line
  state: () => {
    return {
      currentToolId: null,
      product: null,
    };
  },
  mutations: {
    setCurrentToolId(state, toolId) {
      state.currentToolId = toolId;
    },
    setProduct(state, product) {
      state.product = product;
    },
  },
};

